import React, { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import CaseInformation from "src/components/caseInformation";
// import CaseNotes from "src/components/caseNotes";
// import DocumentUpload from "src/components/documentUpload";
// import PatientInformation from "src/components/patientInformation";
import PrescriberInformation from "src/components/prescriberInformation";
import DetailPageInfo from "src/components/detailPageInfo";

import useFetch from "src/hooks/useFetch";
// import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";

import { ManufactureCaseDetailType, ManufactureCaseNotesType } from "../../../src/types/caseDetail";
import { APIEndpoints } from "src/types/apiTypes";
import KAMFAMNotes from "src/components/kamfamNotes";
import { ManufactureCaseDetailAPIResponseType } from "../caseDetail/types";
// import TreatmentStatus from "src/components/caseDetailComp/treatmentStatus";
// import ScheduledTXDate from "src/components/caseDetailComp/scheduled_tx_date";
import ManufactureInsuranceInformations from "src/components/manufacturer/manufactureInsuranceInformation";
import PracticeInformation from "src/components/practiceInformation";
import ReferringPrescriberAndProviderInformation from "src/components/referingPrescriberAndPracticeInformation";
import CopayInformation from "src/components/copayInformation";
import FooterText from "../../components/footerText";

const HubCaseDetail: FC = (): JSX.Element => {
  const { caseId } = useParams();
  const { hideLoader } = useContext(LoaderContext);
  // const { isManufacturer } = useContext(AuthContext);
  const [, setCaseNotes] = useState<ManufactureCaseNotesType[]>([]);
  const [caseDetail, setCaseDetail] = useState<ManufactureCaseDetailType>();
  const [kamfamNotes, setKamFamNotes] = useState<ManufactureCaseNotesType[]>([]);

  const { data: caseDetailObject, error: caseDetailError } =
    useFetch<ManufactureCaseDetailAPIResponseType>(
      APIEndpoints.CASE_DETAIL,
      {},
      { caseId }
    );

  useEffect(() => {
    if (caseDetailObject || caseDetailError) {
      hideLoader();
      if (caseDetailObject) {
        setCaseNotes(caseDetailObject?.data.case_notes);
        setCaseDetail(caseDetailObject?.data);
        caseDetailObject && caseDetailObject.data && caseDetailObject.data.kam_fam_notes
          && caseDetailObject.data.kam_fam_notes.notes &&
          setKamFamNotes(caseDetailObject.data.kam_fam_notes.notes);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDetailObject, caseDetailError]);

  return (
    <section className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill territories-page">
      <div className="container-fluid pt-3 d-flex flex-column flex-fill">
        <div className="row mb-3 align-items-center">
          <div className="col-sm-4 col-12 mb-3 mb-md-0">
            <h2 className="m-0">Case# <span className="badge bg-primary rounded-5">{caseId}</span></h2>
          </div>
          <div className="col-sm-8 col-12 text-md-end">
            <div className={`d-flex d-md-inline-flex px-3 text-center text-white fs-4 rounded-3
              background-color-${caseDetail && caseDetail.case_information ? caseDetail.case_information.color : 1}`}>
              {caseDetail && caseDetail.case_information ? caseDetail.case_information.status : ""}
            </div>
          </div>
        </div>

        {caseDetail ? (
          <>
            {/* Case Information */}
            <CaseInformation caseObject={caseDetail} />
            {/* Benefits Summary */}
            <DetailPageInfo isCasePage={true} benefit_summary={caseDetail.benefit_summary}
              coverage_summary={caseDetail.coverage_summary} caseObject={caseDetail} drug_name={caseDetail.case_information.product}
            />
            {/* KAM/FAM Note */}
            {
              <KAMFAMNotes caseId={caseDetail.case_information.case_id} kamfamNotes={kamfamNotes}
                add_note={caseDetail?.kam_fam_notes?.add_note} updateKamfamNotes={setKamFamNotes}
                drug_name={caseDetail.case_information.product}
              />
            }
            {/* <TreatmentStatus caseId={caseId ? Number(caseId) : 0} /> */}
            {/* Scheduled Date of Service */}
            {/* <ScheduledTXDate caseId={caseId ? Number(caseId) : 0} scheduled_tx_date={caseDetail?.scheduled_tx_date} /> */}
            {/* Case Notes */}
            {/* <CaseNotes caseNotes={caseNotes} setNotes={setCaseNotes} caseObject={caseDetail} /> */}
            {/* Documents */}
            {/* <DocumentUpload setNotes={setCaseNotes}
              caseDocuments={caseDetail.case_documents ? caseDetail.case_documents : []}
              caseId={caseDetail.case_information ? caseDetail.case_information.case_id : 0}
            /> */}

            {/* Prescriber Information */}
            {/* {caseDetail && caseDetail.case_information ? (
              <PrescriberInformation
                drugName={caseDetail.case_information.product}
                title="Prescriber Information"
                prescriber_information={caseDetail.prescriber_information}
              />
            ) : null} */}
             {/* Prescriber Information */}
                        {caseDetail.case_information.product === "ZILRETTA" ? (
                          <PrescriberInformation prescriber_information={caseDetail.prescriber_information}
                              title="Prescriber Information"
                              drugName={caseDetail.case_information.product} />
                        ) : (
                            <>
                                {caseDetail.case_information.treating_provider_as_practice ? (
                                    <div>
                                        <PracticeInformation
                                            practice_information={caseDetail.case_information.treating_provider_as_practice}
                                            title="Treating Prescriber Information" />
                                    </div>
                                ) : (
                                    <div>
                                        <PrescriberInformation
                                            prescriber_information={caseDetail.case_information.treating_prescriber}
                                            title="Treating Prescriber Information"
                                            drugName={caseDetail.case_information.product} />
                                    </div>
                                )}
                                <div>
                                    <PracticeInformation
                                        practice_information={caseDetail.case_information.treating_practice}
                                        title="Treating Facility Information" />
                                </div>
                                {caseDetail.case_information.referring_practice ? (
                                    <ReferringPrescriberAndProviderInformation
                                        practice_information={caseDetail.case_information.referring_practice}
                                        prescriber_information={caseDetail.case_information.referring_prescriber}
                                        title={'Referring Prescriber and Facility Information'} />
                                ) : null}
                            </>
                        )}

 {/* {Copay Information} */}
                          {caseDetail.case_information.product === "ZILRETTA" &&
                              <CopayInformation copay_information={caseDetail.copay_program} />
                                }
            {/* Insurance Information */}
            <div className="card mb-3 rounded-1">
              <div className={`card-header ${caseDetail.case_information.product === 'iovera°' ? 'iovera-theme' : 'zilretta-theme'}`}>
                <h4 className="mb-0">Insurance Information</h4>
              </div>

              <div className="card-body">
                {caseDetail.insurance_information.length > 0
                  ? caseDetail.insurance_information.map((item, index) => (
                    <ManufactureInsuranceInformations
                      key={index}
                      caseId={caseDetail.case_information.case_id}
                      insuranceNumber={index + 1}
                      insuranceInformation={item}
                      drugName={caseDetail.case_information.product}
                    />
                  ))
                  : null}
              </div>
            </div>
          </>
        ) : null}
      </div>
      <FooterText footerType="black"/>
    </section>
  );
};

export default HubCaseDetail;
